// extracted by mini-css-extract-plugin
export default {"FooterSection":"footer-section_FooterSection__1yFgX"};